import { Maybe } from 'types/FMSGraphqlTypes'
import { TCarrierRateTypePreference } from '../types'

export const getRateTypesLabels = (rateType: Maybe<TCarrierRateTypePreference>): string => {
  const { allowsAllIn, allowsDayRate, hasLineHaulFuelSurcharge } = rateType || {}
  return [
    ...(allowsAllIn ? ['All In'] : []),
    ...(allowsDayRate ? ['Day Rate'] : []),
    ...(hasLineHaulFuelSurcharge ? ['Line Haul + Fuel Surcharge'] : []),
  ].join(', ')
}
